import { ServiceApi, routes } from "./config";

//Authentication

export const SendEmail = async (body) =>
  ServiceApi.post(routes.ContactUs, body);
